import { useState, useEffect } from "react";
import { ChakraProvider, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Box, Text, Flex, VStack, Button, Progress, useToast, Center } from "@chakra-ui/react";
import Custheme from "../NewPages/ChakraCustom.js";



const UploadManager = ({ projectId, files, apiFunc, onClose }) => {
  const isOpen = true;
  const [progressMap, setProgressMap] = useState({});
  // const [overallProgress, setOverallProgress] = useState(0);
  const [uploading, setUploading] = useState(true);
  const [success, setSuccess] = useState({});
  const toast = useToast();


  // Close modal when done
  const handleClose = () => { if (onClose) onClose() };

  // Upload files sequentially with progress
  useEffect(() => {
    if (!files || files.length === 0) {
      setUploading(false);
      return;
    }
    const uploadFiles = async () => {
      // const totalBytes = files.reduce((acc, f) => acc + f.size, 0);
      let uploadedBytes = 0;
      try {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          var result = await apiFunc(projectId, [file], (percent) => {
            setProgressMap((prev) => ({ ...prev, [file.name]: Math.min(100, Math.round(percent)) }));//Updating per file progress

            // const fileUploadedBytes = (percent / 100) * file.size;//Updating overall progress

            // const currentOverall = Math.min(100, Math.round(((uploadedBytes + fileUploadedBytes) / totalBytes) * 100));
            // setOverallProgress(currentOverall);
          });

          uploadedBytes += file.size;

          if (result.data) {
            setSuccess((prev) => ({
              ...prev,
              [file.name]: "true",
            }));
          }
        }
        setUploading(false);
        if (result.data) {
          toast({
            title: "Upload completed",
            description: `${files.length} file(s) uploaded successfully`,
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        } else {
          const error = result.error?.message || "Upload failed.";
          toast({
            title: "Upload failed",
            description: error,
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        }
      } catch (error) {
        toast({
          title: "Error",
          description: error,
          status: "Error",
          duration: 3000,
          isClosable: true,
        });
      }
    };
    uploadFiles();
  }, [files, projectId, apiFunc, toast]);

  return (

    <ChakraProvider theme={Custheme}>
      <Modal isOpen={isOpen} onClose={handleClose} isCentered size="sm">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Uploading Files</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              {files.map((file) => (
                <Box key={file.name}
                  padding={"7px"}
                  border="1px solid lightgray"
                  borderRadius="md"
                  shadow={"lg"}
                  mb={6}>

                  <Text fontSize="md" fontWeight="500" wordBreak="break-word" mb={1} >{file.name}</Text>
                  <Text fontSize="sm" color="var(--text-secondary)" mb={1}>size: {(file.size / 1024).toFixed(2)} KB</Text>

                  {(Number(progressMap[file.name]) < 100) ?
                    <Flex justifyItems={"center"} alignItems={"center"} gap={2}>
                      <Progress value={progressMap[file.name] || 0} width="90%" size="xs" borderRadius={"md"} colorScheme="orange" /><Text fontSize="sm">{progressMap[file.name]}%</Text>
                    </Flex> : success[file.name] ? (
                      <Text fontSize="sm" color="green.600" fontWeight="600">
                        Upload successful
                      </Text>
                    ) : (
                      <Text fontSize="sm" color="blue.600" fontWeight="600">
                        Inprogress
                      </Text>
                    )}

                </Box>
              ))}
              {/* <Box mt={4}>
                  <Text fontWeight="bold"> Uploaded: {overallProgress}%</Text>
                  <Progress value={overallProgress} size="md" colorScheme="gray" />
                </Box> */}
              {!uploading && (
                <Button mb={4} onClick={handleClose} colorScheme="green">
                  Close
                </Button>
              )}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </ChakraProvider>

  )
};

export default UploadManager;
